import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import './MainLayout.css';
import Navigation from '@src/App/Components/Core/Navigation/Navigation';
import { isLoggedIn } from '@store/reducer/clientReducer';
import type { AppState } from '@store/store';

import Header from '../../Header/Header';
import { DialogBar } from './DialogBar';
import { Footer } from './Footer';
import OnboardingWelcomeHandler from './OnboardingWelcomeHandler';
import { useNavigationState } from './useNavigationState';

interface LayoutProps {
    inDialog?: boolean;

    children: JSX.Element;
}

/**
 * Renders the Layout component.
 *
 * @param {LayoutProps} props - The props object which contains the necessary data for rendering the Layout.
 * @returns {JSX.Element} - The rendered Layout component.
 */
function Layout(props: LayoutProps) {
    const loggedIn = useSelector((state: AppState) => isLoggedIn(state.client.secret), shallowEqual);
    const { navMode, setNavMode, mobileSidebarOpen, setMobileSidebarOpen, toggleNav, isMobile } = useNavigationState();

    if (props.inDialog) return <>{props.children}</>;
    return (
        <div className="layoutOuter">
            <OnboardingWelcomeHandler />
            <Navigation
                mode={navMode}
                isMobile={isMobile}
                loggedIn={loggedIn}
                onToggle={toggleNav}
                setMode={setNavMode}
                mobileSidebarOpen={mobileSidebarOpen}
                setMobileSidebarOpen={setMobileSidebarOpen}
            />
            <div className="layoutInner">
                <Header toggleNav={toggleNav} navMode={navMode} />
                <div className="outerWrapper">
                    <div
                        style={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            minHeight: isMobile ? 'calc(100vh - 72px - 56px)' : 'auto',
                        }}
                    >
                        <div className={`wrapper`}>
                            <div className="contentOuter">{props.children}</div>
                        </div>
                    </div>
                    <Footer />
                </div>
                <DialogBar />
            </div>
        </div>
    );
}

export default Layout;
